import Col from 'components/ui-elements/Col'
import Row from 'components/ui-elements/Row'
import React from 'react'

const CalloutInfo = (props) => {
  return (
    <Row>
        <Col size={props.size}>
            <br/>
            <div className={`callout callout-${props.type} ${props.className} ${props.margin}`}>
                    {props?.title && <h6>{props.title}</h6>}
                    {props.children}
            </div>
        </Col>
    </Row>
  )
}
CalloutInfo.defaultProps = {
  size: 12,
  type: "info"
}
export default CalloutInfo